function t(r) {
  return r != null && !(Array.isArray(r) && r.length === 0);
}
function e(r, a = !1) {
  return r && (t(r.value) && r.value !== "" || a && t(r.defaultValue) && r.defaultValue !== "");
}
function n(r) {
  return r.startAdornment;
}
export {
  e as a,
  n as i
};
//# sourceMappingURL=utils-Bf5X_KZD.mjs.map
